import { makeStyles } from '@material-ui/styles';
import { Theme } from '@material-ui/core/styles';
import { createStyles } from '@material-ui/core';
import { grey } from 'globals/colors';
import { CSSProperties } from 'react';

export const useStyles = makeStyles(({ spacing, palette }: Theme) =>
  createStyles({
    root: {
      paddingRight: spacing(1),
      display: 'flex',
      alignItems: 'center',
      borderRadius: spacing(0.5),
      border: `1px solid ${palette.grey[200]}`,
      boxShadow: 'none',
    },
    input: {
      flex: 1,
      padding: spacing(2, 1.2),
      '& input': {
        padding: 0,
      },
      '& fieldset': {
        border: 0,
      },
    },
    iconButton: {
      padding: 10,
    },
  })
);

export const getIconStyle = (): CSSProperties => ({
  fill: grey.V3,
});
